import Done from "@mui/icons-material/Done"; // CUSTOM ICON COMPONENTS
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import styled from "@mui/material/styles/styled";
import { format } from "date-fns";
import { Fragment } from "react";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import {
  FlexBetween,
  FlexBox,
} from "src/lib/components/salify-next-layout/default/components/flex-box"; // STYLED COMPONENTS
import Delivery from "src/lib/components/salify-next-layout/default/icons/Delivery";
import PackageBox from "src/lib/components/salify-next-layout/default/icons/PackageBox";
import TruckFilled from "src/lib/components/salify-next-layout/default/icons/TruckFilled"; // GLOBAL CUSTOM COMPONENTS
import { ORDER_STATUS } from "src/lib/fetcher/client";

const StyledFlexbox = styled(FlexBetween)(({ theme }) => ({
  flexWrap: "wrap",
  marginTop: "2rem",
  marginBottom: "2rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  "& .line": {
    height: 4,
    minWidth: 50,
    flex: "1 1 0",
    [theme.breakpoints.down("sm")]: {
      flex: "unset",
      height: 50,
      minWidth: 4,
    },
  },
}));
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  top: -5,
  right: -5,
  width: 22,
  height: 22,
  position: "absolute",
  bgcolor: theme.palette.grey[200],
  color: theme.palette.success.main,
}));

const OrderProgress = () => {
  const order = SalifyFallback.useSelect("output:order.data");
  const STEP_ICONS = [PackageBox, TruckFilled, Delivery];
  const ORDER_STATUS_LIST = [
    ORDER_STATUS.New,
    ORDER_STATUS.Pending,
    ORDER_STATUS.Confirmed,
    ORDER_STATUS.Completed,
  ];
  const statusIndex = ORDER_STATUS_LIST.indexOf(order.status ?? order.state);

  return (
    <Card
      sx={{
        p: "2rem 1.5rem",
        mb: 4,
      }}
    >
      <StyledFlexbox>
        {STEP_ICONS.map((Icon, ind) => (
          <Fragment key={ind}>
            <Box position="relative">
              <Avatar
                alt="shipping"
                sx={{
                  width: 64,
                  height: 64,
                  color: ind <= statusIndex ? "white" : "primary.main",
                  bgcolor: ind <= statusIndex ? "primary.main" : "grey.300",
                }}
              >
                <Icon color="inherit" fontSize="large" />
              </Avatar>

              {ind < statusIndex ? (
                <StyledAvatar alt="done">
                  <Done
                    color="inherit"
                    sx={{
                      fontSize: 16,
                    }}
                  />
                </StyledAvatar>
              ) : null}
            </Box>

            {ind < STEP_ICONS.length - 1 ? (
              <Box className="line" bgcolor={ind < statusIndex ? "primary.main" : "grey.300"} />
            ) : null}
          </Fragment>
        ))}
      </StyledFlexbox>

      <FlexBox
        justifyContent={{
          xs: "center",
          sm: "flex-end",
        }}
      >
        <Paragraph
          p="0.5rem 1rem"
          textAlign="center"
          borderRadius="300px"
          color="white"
          bgcolor="primary.light"
        >
          <SalifyFallback.LabelTemplate
            path="Estimated Delivery Date"
            default="Dự kiến ngày giao hàng"
          />{" "}
          <b>
            {order.orderDelivery?.expectedDeliveryTime
              ? format(new Date(order.orderDelivery?.expectedDeliveryTime), "dd MM , yyyy hh:mm")
              : order.orderDelivery?.expectedOrderDeliveryNotes || "-"}
          </b>
        </Paragraph>
      </FlexBox>
    </Card>
  );
};

export default OrderProgress;
